import React, { useState, createContext } from "react";

const ReplyMessageContext = createContext();

const ReplyMessageProvider = ({ children }) => {
	const [replyingMessage, setReplyingMessage] = useState(null);
	// Alvo de resposta a um comentário do Instagram escolhido pelo atendente.
	// Formato: { commentId, mode: "public" | "private", permalink, preview }
	const [instagramReplyTarget, setInstagramReplyTarget] = useState(null);

	return (
		<ReplyMessageContext.Provider
			value={{
				replyingMessage,
				setReplyingMessage,
				instagramReplyTarget,
				setInstagramReplyTarget,
			}}
		>
			{children}
		</ReplyMessageContext.Provider>
	);
};

export { ReplyMessageContext, ReplyMessageProvider };
